(function ($, window, document, undefined) {
    function moveResetButton() {
        var recurrence = $(".tribe-events-user-recurrence-toggle");
        var reset = $("#tribe_events_filters_reset");
        var target = $("#tribe_events_filter_item_featuredevent");

        reset.detach().prependTo(target);
        recurrence.detach().appendTo(target);
    }

    function initCardClickHandlers() {
        $('.tribe__wrapper[data-href]').on('click', function(e) {
            if ($(e.target).closest('a').length) return;
            var href = $(this).data('href');
            if (href) {
                if (e.ctrlKey || e.metaKey) {
                    window.open(href, '_blank');
                } else {
                    window.location.href = href;
                }
            }
        });
    }

    $(document).ready(function () {
        moveResetButton();
        initCardClickHandlers();

        enquire.register("screen and (max-width:767px)", {
            unmatch: function () {
                $("body")
                    .removeClass("tribe-filters-closed")
                    .addClass("tribe-filters-open");
                localStorage.setItem("tribe_events_filters_wrapper", "open");
            },
        });

        enquire.register("screen and (min-width:768px)", {
            match: function () {
                $("body")
                    .removeClass("tribe-filters-closed")
                    .addClass("tribe-filters-open");
                localStorage.setItem("tribe_events_filters_wrapper", "open");
            },
        });

        enquire.register("screen and (max-width:1024px)", {
            match: function () {
                $(".admin-bar").addClass("tribe-mobile tribe-filters-closed");
            },

            unmatch: function () {
                $(".admin-bar")
                    .removeClass("tribe-mobile tribe-filters-closed")
                    .addClass("tribe-filters-open");
            },
        });
    });
})(jQuery, window, document);
